import type {
  TelemetryIdentity,
  ScreenCompletion,
} from "@wishlink/applens-core";
import type { Activation } from "@wishlink/applens-web";
export type {
  Binding,
  BindingOptions,
  Clock,
  RootObservation,
  HttpObservation,
} from "@wishlink/applens-web";

/** Creator activation envelope; identity is static for a controller lifetime. */
export interface LocalConfig extends Activation {
  exporterPath: string;
  identity: TelemetryIdentity;
}
export type DeploymentConfig = Omit<LocalConfig, "exporterPath">;
export interface HomeState {
  configReady?: boolean;
  creatorReady?: boolean;
  branchCommitted?: boolean;
  socialPending?: boolean;
  redirecting?: boolean;
  blockingError?: boolean;
  partialError?: boolean;
}
export interface HomeHandle {
  readonly key: string;
  readonly root: { readonly closed: boolean } | undefined;
  report(state: HomeState): void;
  finish(completion: ScreenCompletion): boolean;
}
export function safely<T>(work: () => T, fallback: T): T {
  try {
    return work();
  } catch {
    return fallback;
  }
}
